/**
 * Alert Manager - Handles alerts without automatic dismissal
 */
export class AlertManager {
    init() {
        // No hay auto-dismiss, las alertas se mantienen hasta que el usuario las cierre
    }
    showAlert(message, type = 'info', dismissible = true) {
        const alertId = `alert-${Date.now()}`;
        const dismissibleAttr = dismissible ? 'alert-dismissible fade show' : '';
        const closeButton = dismissible ? `
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        ` : '';
        const iconMap = {
            success: 'bi-check-circle-fill',
            danger: 'bi-exclamation-triangle-fill',
            warning: 'bi-exclamation-circle-fill',
            info: 'bi-info-circle-fill'
        };
        const alertHtml = `
            <div class="alert alert-${type} ${dismissibleAttr}" id="${alertId}" role="alert">
                <i class="bi ${iconMap[type]} me-2"></i>
                ${message}
                ${closeButton}
            </div>
        `;
        // Find alert container or append to body
        let container = document.querySelector('.alert-container');
        if (!container) {
            // Create container if it doesn't exist
            container = document.createElement('div');
            container.className = 'alert-container position-fixed top-0 end-0 p-3 alert-z-index';
            document.body.appendChild(container);
        }
        container.insertAdjacentHTML('beforeend', alertHtml);
    }
    clearAllAlerts() {
        const alerts = document.querySelectorAll('.alert');
        alerts.forEach((alert) => {
            const bsAlert = window.bootstrap.Alert.getOrCreateInstance(alert);
            if (bsAlert) {
                bsAlert.close();
            }
        });
    }
}
